import { defineNuxtPlugin } from '#imports'
import { useAmazonState } from '~/composables/useAmazonState'

export default defineNuxtPlugin(() => {
  const { checkIsAmazon } = useAmazonState()

  // Initialize Amazon state based on the current route
  checkIsAmazon()

  return {
    provide: {
      amazonState: useAmazonState(),
    },
  }
})
